import { envConfig } from '@root/env';
import { Post } from '@/service/request/server';

const baseUrl = envConfig.formalServer + '/cotton/admin/pay/order/';

function baseApi() {

    function update(data) {
        return Post(baseUrl + 'updatePayOrder', data);
    }

    function queryList(data) {
        return Post(baseUrl + 'queryPayOrder', data);
    }


    return {
        update, queryList
    };
}

export const exportPayOrderApi = baseApi();
